import { createFileRoute } from '@tanstack/react-router'
import { Inbox } from 'lucide-react'
import { z } from 'zod'
import { ReviewScreen } from '@/screens/workspace/SCR-010-review'

export const Route = createFileRoute('/_app/w/$ws/review')({
  staticData: { screen: {"id":"SCR-010","title":"Review queue","group":"Workspace","perm":"memory.curate","order":10,"description":"Proposed memories and cards waiting for a decision.", icon: Inbox } },
  validateSearch: z.object({
    tab: z.enum(['proposals', 'cards', 'retention']).optional(),
    status: z.enum(['pending', 'deferred', 'decided']).optional(),
  }),
  component: ReviewScreen,
})
